export enum POSCoverStatus {
    OPENED = "OPENED",
    CLOSED = "CLOSED",
    UNKNOWN = "UNKNOWN",
}
